import { $, owlCarousel } from "./imports";

const teamCarousel = () => {

    if($('.team .team__list .team-card').length > 1){
        let $teamAboutCarousel = $('.team .team__list').addClass('owl-carousel').owlCarousel({
            nav: false,
            dots: true,
            navText: [
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M15.514,6l1.627,1.627-5.285,5.3,5.285,5.3-1.627,1.627L8.59,12.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M10.217,6,8.59,7.627l5.285,5.3L8.59,18.22l1.627,1.627,6.923-6.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>'
            ],
            // rewind: true,
            loop: true,
            autoplay: true,
            autoplayTimeout: 8000,
            autoplayHoverPause: true,
            margin: 16,
            // center: true,
            responsive: {
                0: {
                    items: 1,
                    margin: 16,
                },
                768: {
                    items: 2,
                },
                992: {
                    nav: true,
                    items: 3,
                }
            }
        });
    }
}

export default teamCarousel;